<template>
  <div id="expense-report" class="wrrapper">
    <page-heading title="Expense Report">
      <template #content>
        <div class="flex align-center no-print">
          <DateRangePicker @update="updateDate" />
          <Select
            v-if="isAdmin"
            class="mr-2"
            styles="expenses-select"
            :input="handleBranchChange"
            :options="brachData"
            :placeholder="
              brachData.length
                ? brachData && brachData.find(item => item.key == 1).name
                : ''
            "
          />
          <ExportButtons
            style="margin-left: 8px;"
            @pdf="handleExportPdf"
            @excel="handleExportExcel"
          />
        </div>
      </template>
    </page-heading>
    <div class="content" id="expense--report">
      <data-table
        :loading="loading"
        :cols="columns"
        :rows="expensesReport"
        height="calc(100vh - 15rem)"
        total
      >
      </data-table>
    </div>
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
import { formatedDate, getBranchLogo } from "@/utils/helpers";
import DateRangePicker from "@/components/DateRangePIcker";
import Select from "@/components/Select";
import ExportButtons from "@/components/ExportButtons.vue";
import { exportReportPdf, exportReportExcel } from "@/utils/reportExport";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    DateRangePicker,
    DataTable,
    Select,
    ExportButtons
  },
  data() {
    return {
      filters: {
        start_date: formatedDate(),
        end_date: formatedDate(),
        branchId: ""
      },
      columns: [
        { column: "serial", label: "#", width: "60" },
        { column: "date", label: "Date", sortable: true },
        { column: "name", label: "Name", sortable: true },
        { column: "narration", label: "Narration", sortable: true },
        {
          column: "amount",
          label: "Amount",
          formatAmount: true,
          sortable: true,
          sum: true
        }
      ],
      isAdmin: false,
      brachData: [],
      bussinessLogoUrl: "",
      branchLogoUrl: ""
    };
  },
  methods: {
    ...mapActions("expenses", ["expenseReport", "fetchBranch"]),
    updateDate(val) {
      this.filters.end_date = formatedDate(val.endDate);
      this.filters.start_date = formatedDate(val.startDate);
      this.expenseReport(this.filters);
    },
    exportInput() {
      return {
        title: "Expense Report",
        dateRange: {
          start: this.filters.start_date,
          end: this.filters.end_date
        },
        printedBy: this.user.full_name,
        businessLogoUrl: this.bussinessLogoUrl,
        branchLogoUrl: this.branchLogoUrl,
        cols: this.columns,
        rows: this.expensesReport,
        fileName: "expense-report",
        summary: [
          {
            label: "Total",
            value: this.expensesReport
              .reduce((sum, row) => sum + (Number(row.amount) || 0), 0)
              .toLocaleString()
          }
        ]
      };
    },
    handleExportPdf() {
      exportReportPdf(this.exportInput());
    },
    handleExportExcel() {
      exportReportExcel(this.exportInput());
    },
    handleBranchChange(val) {
      if (val && val != null) {
        const object = getBranchLogo(this.fetchUserBranch, val.key);
        this.branchLogoUrl = object;
        this.expenseReport(this.filters);
      }
      if (val === null) {
        this.expenseReport(this.filters);
      }
    }
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      expensesReport: "expenses/expensesReport",
      user: "auth/userInfo",
      fetchUserBranch: "expenses/fetchUserBranch",
      settings: "bussiness/settings"
    })
  },
  async mounted() {
    this.isAdmin = this.user.userRole.some(({ name }) => name === "admin");
    await this.fetchBranch();
    await this.fetchUserBranch?.map(elem => {
      this.brachData.push({ name: elem.name, key: elem.id });
    });
    this.branchLogoUrl = getBranchLogo(
      this.fetchUserBranch,
      this.user?.userBranchId
    );

    this.bussinessLogoUrl = this.user?.bussinessLogoUrl;

    this.expenseReport(this.filters);
  }
};
</script>

<style>
@import "../../assets/css/print.css";
</style>
